export default "__VITE_PUBLIC_ASSET__6d2a9c45__"